import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'log',
    label: 'Log Report',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
